import { render, staticRenderFns } from "./properties-seo.vue?vue&type=template&id=a20deab6&scoped=true"
import script from "./properties-seo.vue?vue&type=script&lang=js"
export * from "./properties-seo.vue?vue&type=script&lang=js"
import style0 from "./properties-seo.vue?vue&type=style&index=0&id=a20deab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20deab6",
  null
  
)

export default component.exports